export default __webpack_public_path__ + "static/media/linkedin.7be0d03c.png";